<script>
import CardGoToStep from '@/views/Scenario/StepEditor/Card/CardGoToStep.vue'

export default {
    name: 'CardGoToStep',
    extends: CardGoToStep,
    computed: {
        stepList () {
            return this.card.config.step_list
        }
    }
}
</script>

<style scoped lang="scss">

</style>
